import React from 'react';
import '../CSS/HumanResource.css';

const HumanResource: React.FC = () => {
  return (
    <div className="human-resource-page">
      <div className="human-resource_banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Human Resource</h1>
        </div>
      </div>

      <div className="hr_mantra">
        <p>Generative AI (GenAI) offers new ways for CHROs and HR leaders to enhance efficiency, innovation and employee engagement. As an HR leader, it's crucial to benchmark your progress and strategically plan your GenAI implementation to stay ahead.</p>
      </div>

      <div className="hr_use_cases">
        <div className="hr_use_cases-content">
          <h2 className="hr_use_cases-title">Use Cases</h2>
          
          <div className="hr_stats_card">
            <h3 className="stats_title">Your people are primed for AI.</h3>
            <div className="stats_container">
              <div className="stat_item">
                <div className="stat_image">
                  <img src="/Assets/Human Resource/73-percentage.svg" alt="73% of employees want AI implementation" />
                </div>
                <p className="stat_description">of employees want their company to implement AI across their organization.</p>
              </div>
              
              <div className="stat_item">
                <div className="stat_image">
                  <img src="/Assets/Human Resource/61-percentage.svg" alt="61% of workers want AI training" />
                </div>
                <p className="stat_description">of workers think they could benefit from training around how to use AI in the workplace.</p>
              </div>
              
              <div className="stat_item">
                <div className="stat_image">
                  <img src="/Assets/Human Resource/76-percentage.svg" alt="76% of employees agree AI helps find information" />
                </div>
                <p className="stat_description">of employees agree that AI could make it easier for them to find information.</p>
              </div>
            </div>
          </div>

          <div className="hr_cards">
            <div className="hr_card">
              <h3 className="card_title">We deliver AI with a human touch.</h3>
              <p className="card_description">From flattening the learning curve to finding out how your workforce is feeling about AI—we're here to support you as you lead in the future of work.</p>
            </div>
            
            <div className="hr_card">
              <h3 className="card_title">Upskilling makes the sky the limit.</h3>
              <p className="card_description">We deliver targeted, AI-focused learning modules to help train and up-skill your workforce.</p>
            </div>
            
            <div className="hr_card">
              <h3 className="card_title">Curated experiences for all.</h3>
              <p className="card_description">Connect with your employees to share plans and practices through announcements, personalized journeys, and more.</p>
            </div>
            
            <div className="hr_card">
              <h3 className="card_title">Hear how it's going.</h3>
              <p className="card_description">Gather direct input from your employees and feedback to see how they're feeling at every step.</p>
            </div>
          </div>
        </div>
      </div>

      {/* HR Stats Section - Mobile (480px) */}
      <div className="hr_use_cases mobile-hr-use-cases">
        <div className="hr_use_cases-content">
          <h2 className="hr_use_cases-title">Use Cases</h2>
          
          <div className="hr_stats_card mobile-hr-stats-card">
            <h3 className="stats_title">Your people are primed for AI.</h3>
            <div className="stats_container mobile-stats-container">
              <div className="stat_item mobile-stat-item">
                <div className="stat_image mobile-stat-image">
                  <img src="/Assets/Human Resource/73-percentage.svg" alt="73% of employees want AI implementation" />
                </div>
                <p className="stat_description mobile-stat-description">of employees want their company to implement AI across their organization.</p>
              </div>
              
              <div className="stat_item mobile-stat-item">
                <div className="stat_image mobile-stat-image">
                  <img src="/Assets/Human Resource/61-percentage.svg" alt="61% of workers want AI training" />
                </div>
                <p className="stat_description mobile-stat-description">of workers think they could benefit from training around how to use AI in the workplace.</p>
              </div>
              
              <div className="stat_item mobile-stat-item">
                <div className="stat_image mobile-stat-image">
                  <img src="/Assets/Human Resource/76-percentage.svg" alt="76% of employees agree AI helps find information" />
                </div>
                <p className="stat_description mobile-stat-description">of employees agree that AI could make it easier for them to find information.</p>
              </div>
            </div>
          </div>

          <div className="hr_cards mobile-hr-cards">
            <div className="hr_card mobile-hr-card">
              <h3 className="mobile-hr-card-card_title">We deliver AI with a human touch.</h3>
              <p className="mobile-hr-card-card_description">From flattening the learning curve to finding out how your workforce is feeling about AI—we're here to support you as you lead in the future of work.</p>
            </div>
            
            <div className="hr_card mobile-hr-card">
              <h3 className="mobile-hr-card-card_title">Upskilling makes the sky the limit.</h3>
              <p className="mobile-hr-card-card_description">We deliver targeted, AI-focused learning modules to help train and up-skill your workforce.</p>
            </div>
            
            <div className="hr_card mobile-hr-card">
              <h3 className="mobile-hr-card-card_title">Curated experiences for all.</h3>
              <p className="mobile-hr-card-card_description">Connect with your employees to share plans and practices through announcements, personalized journeys, and more.</p>
            </div>
            
            <div className="hr_card mobile-hr-card">
              <h3 className="mobile-hr-card-card_title">Hear how it's going.</h3>
              <p className="mobile-hr-card-card_description">Gather direct input from your employees and feedback to see how they're feeling at every step.</p>
            </div>
          </div>
        </div>
      </div>

      {/* AI Innovation Section - Desktop */}
      <div className="ai_innovation desktop-hr-innovation">
        <div className="ai_innovation-content">
          <h2 className="ai_innovation-title">AI Innovation For Your Business</h2>
          
          {/* Section 1: AI Knowledge Base - Image Left */}
          <div className="hr_image_left">
            <div className="section-image">
              <img src="/Assets/Human Resource/ai-knowledge-base-section-image.png" alt="AI Knowledge Base" />
            </div>
            <div className="hr_section_text">
              <h3 className="hr_section_subtitle">AI Knowledge Base</h3>
              <h4 className="hr_section_subheading">Assist Your Employees Without Lifting a Finger</h4>
              <p className="hr_section_description">Our AI knowledge base is like your company's personal HR chatGPT. It will instantly answer questions on your company specific HR policies, company handbook policies, leave policies, and more.</p>
            </div>
          </div>

          {/* Section 2: AI Document Creation - Image Right */}
          <div className="hr_image_right">
            <div className="section-image">
              <img src="/Assets/Human Resource/ai-document-creation-section-image.png" alt="AI Document Creation" />
            </div>
            <div className="hr_section_text">
              <h3 className="hr_section_subtitle">AI Document Creation</h3>
              <h4 className="hr_section_subheading">Employee Forms Have Never Been Easier</h4>
              <p className="hr_section_description">Use the robust AI capabilities in our magic documents feature to quickly and 'magically' generate form templates. Simply ask our AI what you are trying to produce and sit back while it generates your draft. Need an offer letter for an HR executive in New York? Or maybe a performance improvement plan template for a customer service representative? Never start from scratch again with our embedded AI support.</p>
            </div>
          </div>

          {/* Section 3: AI-Powered Summaries - Image Left */}
          <div className="hr_image_left">
            <div className="section-image">
              <img src="/Assets/Human Resource/ai-powered-summaries-section-image.png" alt="AI-Powered Summaries" />
            </div>
            <div className="hr_section_text">
              <h3 className="hr_section_subtitle">AI-Powered Summaries</h3>
              <h4 className="hr_section_subheading">Accelerate Performance Reviews with AI</h4>
              <p className="hr_section_description">Embedded directly within our performance management tool, our AI-powered summary feature simplifies the way you process employee performance data. Inside each performance review, you'll find all relevant employee information—past reviews, employment history, goals, and more—conveniently organized in one place.</p>
              <p className="hr_section_description">Need to quickly summarize that data? With just one click, our AI summary tool instantly compiles a concise overview, helping you make faster, data-driven decisions. Whether you're preparing for a review meeting or need a quick performance snapshot while completing the review, AI-driven insights save time and enhance accuracy.</p>
            </div>
          </div>
        </div>
      </div>

      {/* AI Innovation Section - Mobile (480px) */}
      <div className="ai_innovation mobile-hr-innovation">
        <div className="ai_innovation-content">
          <h2 className="ai_innovation-title mobile_ai_innovation-title">AI Innovation For Your Business</h2>
          
          {/* Section 1: AI Knowledge Base - Image Above Text */}
          <div className="mobile-hr-section">
            <div className="mobile-hr-image">
              <img src="/Assets/Human Resource/ai-knowledge-base-section-image.png" alt="AI Knowledge Base" />
            </div>
            <div className="mobile-hr-text">
              <h3 className="mobile-hr-subtitle">AI Knowledge Base</h3>
              <h4 className="mobile-hr-subheading">Assist Your Employees Without Lifting a Finger</h4>
              <p className="mobile-hr-description">Our AI knowledge base is like your company's personal HR chatGPT. It will instantly answer questions on your company specific HR policies, company handbook policies, leave policies, and more.</p>
            </div>
          </div>

          {/* Section 2: AI Document Creation - Image Above Text */}
          <div className="mobile-hr-section">
            <div className="mobile-hr-image">
              <img src="/Assets/Human Resource/ai-document-creation-section-image.png" alt="AI Document Creation" />
            </div>
            <div className="mobile-hr-text">
              <h3 className="mobile-hr-subtitle">AI Document Creation</h3>
              <h4 className="mobile-hr-subheading">Employee Forms Have Never Been Easier</h4>
              <p className="mobile-hr-description">Use the robust AI capabilities in our magic documents feature to quickly and 'magically' generate form templates. Simply ask our AI what you are trying to produce and sit back while it generates your draft. Need an offer letter for an HR executive in New York? Or maybe a performance improvement plan template for a customer service representative? Never start from scratch again with our embedded AI support.</p>
            </div>
          </div>

          {/* Section 3: AI-Powered Summaries - Image Above Text */}
          <div className="mobile-hr-section">
            <div className="mobile-hr-image">
              <img src="/Assets/Human Resource/ai-powered-summaries-section-image.png" alt="AI-Powered Summaries" />
            </div>
            <div className="mobile-hr-text">
              <h3 className="mobile-hr-subtitle">AI-Powered Summaries</h3>
              <h4 className="mobile-hr-subheading">Accelerate Performance Reviews with AI</h4>
              <p className="mobile-hr-description">Embedded directly within our performance management tool, our AI-powered summary feature simplifies the way you process employee performance data. Inside each performance review, you'll find all relevant employee information—past reviews, employment history, goals, and more—conveniently organized in one place.</p>
              <p className="mobile-hr-description">Need to quickly summarize that data? With just one click, our AI summary tool instantly compiles a concise overview, helping you make faster, data-driven decisions. Whether you're preparing for a review meeting or need a quick performance snapshot while completing the review, AI-driven insights save time and enhance accuracy.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HumanResource; 